import React from 'react';
import Navbar from './components/Navbar';
// import Animation from './components/Animation';
import Connect from './components/Connect';
import Skills from './components/Skills';
import Background from './components/Background';
import Projects from './components/Projects';
import Contact from './components/Contact';
import './App.css';

function App() {
  return (
    <div className="App">
      <Navbar />
      <Home />      
      <Skills />
      <Background />
      <Projects />
      <Contact />
    </div>
  );
}

const Home = () => (
  <div className="home section" id="home">
    <div className="home-content">
      <div className="summary align-right">
        <div className="summary-content">
          
          <h1>
            Mark Stokes
          </h1>
          <p>
            (909)838-7845
          </p>
          
          <Connect linkedin="#" github="#" contact="contact"
          resume="https:\/\/miercolesdelmerk.42web.io/mark_resume_computer_teaching_2024.pdf"/>
          
        </div>
      </div>
    
    </div>
    <div id="skills-marker"/>
  </div>
);



export default App;
